module.exports = __webpack_public_path__ + "img/estonia.a0742ce.webp";